<div style="background: #161616;">
  <div #myCharts echarts [options]="chartOptionPie" class="demo-chart" (chartInit)="onChartInit($event)"></div>
  <!--  <div *ngIf="noData" class="no-data">-->
  <!--    <div>-->
  <!--      You can generate this chart by uploading properties and entering buyers' details.-->
  <!--      <button mat-button (click)="goToProject()">Upload Property</button>-->
  <!--    </div>-->
  <!--    <img src="./assets/images/buyer-demo.png">-->
  <!--  </div>-->
</div>